import SupplierComponent from '../SupplierComponent.vue'

export default [
    {
        path: '/trade_rate_suppliers_directory',
        component: SupplierComponent,
        name: 'trade_rate_suppliers_directory'
    }
]